import User from "./user";
import Storage from "./storage.service";
import Globals from "./globals";
import Helpers from "./helpers";
import Products from "./products.service";
import Flow from "./flow.service";
import HTTP from "./http.service";
import Numbers from "./number.service";
import Promotions from "./promotions.service";
import {userHasDevicePlan, userHasDeviceByDeliveryType} from "./vip.bundle.service";
import Settings from "./settings";
// import Events from "./events.service";

import MiddleMan from "./plans.middleman";

var PlansService = {};

PlansService.getEligibility = (plan, feature = "") => {
	if (plan) {
		let eligibility = plan["PackageEligibility"] || [];
		return (eligibility && eligibility.indexOf(feature) > -1);
	} else {
		return false;
	}
};

PlansService.getPlanFromValues = (values_arr) => {
	let commitment = values_arr[0];
	let product = Products.getProductByCommitment(commitment);
	let values = {};
	for (let index in Settings.types) {
		let hindex = parseInt(index);
		let type = Settings.types[index];
		values[type] = values_arr[hindex + 1];
	}

	let ids = [];

	let product_group = Storage.get("PlansbyProductCode")[product.ProductCode];

	let vmo_subplans = product_group["vmo_subplans"];

	for (let subplan_id of Object.keys(vmo_subplans)) {
		let subplan = vmo_subplans[subplan_id];
		let subplan_type = subplan["Type"];
		let subplan_val = subplan["vmo_ValueFormatted"];
		let our_val = values[subplan_type];

		if (our_val === Settings.unlimited_text_short) {
			our_val = Settings.unlimited_text;
		}

		if ("" + subplan_val === "" + our_val) {
			ids.push(parseInt(subplan_id));
		}
	}

	return ids.sort();
};

// @Todo
PlansService.isVipPlan = () => {
	let flags = Storage.get("flow_status_flags");
	return flags?.has_vip;
}

PlansService.isValuePlan = (plan) => {
	if(plan && plan["vmo_subplans_ids_sorted"]){
		let lookup = plan["vmo_subplans_ids_sorted"].join(",");
		let default_product = Products.getProductByCommitment(1);
		let PlansbyProductCode = Storage.get("PlansbyProductCode");
		if(default_product && PlansbyProductCode){
			let group = PlansbyProductCode[default_product.ProductCode];
			if(group){
				let locked_plans_lookups = group["vmo_locked_plans"]["by_lookup"];
				locked_plans_lookups = [...new Set(locked_plans_lookups)];
				return (locked_plans_lookups.indexOf(lookup) !== -1);
			}
		}
	}
	return false;
}

// @Todo
PlansService.isPaygPlan = (plan) => {
	const product = Storage.get("selectedProduct")
	if(!product) return false
	return product.ProductCategory === "PAYG"
}

PlansService.checkParams = () => {
	let fromParams = false;
	let params_combo = false;
	let saved_plan = Storage.get("saved_plan");

	let saved_plan_combo = null;

	if (saved_plan) {
		saved_plan_combo = PlansService.getCustomCombo(saved_plan);
		params_combo = saved_plan_combo;
	} else {
		if (Storage.get("preset")) {
			params_combo = Storage.get("preset");
		} else {
			if (Storage.get("custom_combo", true)) {
				params_combo = Storage.get("custom_combo", true);
			}
		}
	}

	if (params_combo) {
		let params_values = params_combo.split("-");

		if (params_values.length === 4) {
			let commitment = params_values[0];

			let plan_ids = PlansService.getPlanFromValues(params_values);

			fromParams = {
				commitment: commitment,
				ids: plan_ids,
			};
		}
	}

	

	return fromParams;
};

PlansService.selectInitialPlan = () => {
	let business = Storage.get("businessConfig");

	let default_selected_plan = business["default_selected_plan"];

	let fromParams = PlansService.checkParams();

	if (fromParams) {
		let product = Products.getProductByCommitment(fromParams.commitment);

		if (product && fromParams.ids) {
			Products.selectProduct(product, "333");
			if (fromParams.ids.length === Settings.types.length) {
				default_selected_plan = fromParams.ids;
			}
		}
	}

	let plan = PlansService.getCustomCombinationFromIDs(default_selected_plan);
	if(PlansService.isValuePlan(plan)){
		plan = PlansService.getCustomCombinationFromIDs(business["default_selected_plan"]);
	}

	// if (!PlansService.planFromIDExists(default_selected_plan)) {
	//   default_selected_plan = PlansService.getFoolProofCustomPlan();
	// }

	PlansService.selectCustomPlan(plan);

};

PlansService.checkInternationalMinutes = (proceedAction) => {
	let plan = Storage.get("selectedCustomPlan");
	let minutes = 0;
	if (plan && plan["vmo_subplans_ids_by_type"]) {
		let int_id = plan["vmo_subplans_ids_by_type"]["VOICE-INT"];
		let int_plan = plan["vmo_subplans"][int_id];
		minutes = int_plan["vmo_ValueFormatted"];
	}

	if (minutes > 0) {
		PlansService.toggleInternationalModal(true);
	} else {
		PlansService.toggleInternationalModal(false);
		proceedAction();
	}
};

PlansService.toggleInternationalModal = (val = "") => {
	if (val === "") {
		val = !Storage.get("showInternationalModal");
	}
	Storage.set("showInternationalModal", val);
};

PlansService.getCustomCombinationFromIDs = (combination_array) => {
	if (typeof combination_array === "string") {
		combination_array = combination_array.split(",");
	}

	combination_array = combination_array.sort();

	let default_product = Products.getProductByCommitment(1);

	let PlansbyProductCode = Storage.get("PlansbyProductCode");

	let product_plans = PlansbyProductCode[default_product.ProductCode];

	let plan_to_select =
	product_plans["vmo_packages"][combination_array.join(",")];
	if (!plan_to_select) {
		let cheapestPlanIds = PlansService.findCheapestPlan(default_product.ProductCode);
		if (cheapestPlanIds) {
			plan_to_select =product_plans["vmo_packages"][cheapestPlanIds];
		}
	}
	return plan_to_select;
};

PlansService.findCheapestPlan = (product_code) => {
	const allPlans = Storage.get("PlansbyProductCode");
	const allIDs =  Object.keys(allPlans[product_code]?.vmo_packages)
	const lowest = allIDs?.find(p=>allPlans[product_code].vmo_packages[p]?.PackagePrice?.PlanNetPrice === 82.95)
	return lowest
}

PlansService.setReservationTypes = (type) => {
	let config = {
		method: "get",
		url: "/numbers/reservation?reservation_types=" + type,
	};
	return HTTP(config);
};

PlansService.savePlan = (minors = false) => {
	let selectedPlan = Storage.get("selectedCustomPlan");

	// let formatted_plan_details = Object.keys(selectedPlan["vmo_subplans"]).map(subplan => {
	// 	return `${selectedPlan["vmo_subplans"][subplan]['Type']} : ${selectedPlan["vmo_subplans"][subplan]['vmo_ValueFormatted']}`
	// }).join(',');
	// Events.user_passes_plan_selection(formatted_plan_details);

	let saved_plan = Storage.get("saved_plan");
	let currentProduct = Storage.get("selectedProduct");
	if (saved_plan){
		//check for commitment or plan changes, if no change do not send save request
		let planChanged = (saved_plan.product?.ProductCode !== currentProduct?.ProductCode) ||
		(saved_plan.product?.CommitmentType !== currentProduct?.CommitmentType);

		if (!planChanged){
			for (let type of Settings.types){
				if (saved_plan['vmo_subplans_ids_by_type']?.[type] !== selectedPlan['vmo_subplans_ids_by_type']?.[type]){
					planChanged = true;
					break;
				}
			}
		}
		if (!planChanged) return Promise.resolve(true);
		
	}
	
	//if plan has device, and user changes plan, keep device id so it will not be overwritten:
	//only with annual commitment:
	let devicePlan = userHasDevicePlan(saved_plan);
	if (devicePlan?.ID && currentProduct.CommitmentDuration === 12){
		selectedPlan["vmo_subplans_ids_sorted"].push(devicePlan.ID);
	}
	let data = {
		plan_ids: selectedPlan["vmo_subplans_ids_sorted"].join(","),
		product_code: Storage.get("selectedProduct")["ProductCode"],
	};

	if (Storage.get("selected_recharge")) {
		data["recharge_amount"] = Storage.get("selected_recharge");
	}
if(Storage.get("invitation_code")){
	data["invitation_code"] = Storage.get("invitation_code");
};
	Storage.clear("selected_recharge");

	if (minors){
		data['features'] = 'minor'
	}

	let config = {
		method: "post",
		url: "/plans/saved_plans",
		data: data,
	};
	return HTTP(config);
};

PlansService.saveCustomPlan = (minors = false) => {
	let product = Products.getCurrentProduct();
			// pass nothing to Flow.next() after saving yearly plans 
			// to avoid forced redirection to number page
			// pass 'plan' with other commitments to go always to upsell page
			let commitment = product?.CommitmentDuration;
			let currentRoute;
			if (commitment !== 12) currentRoute = 'plan';
			Products.saveProduct(product).then((res) => {
			PlansService.savePlan(minors).then((response) => {
				User.flowStatus(13)
					.then((res) => {
						Flow.next(currentRoute);
						setTimeout(() => {
							PlansService.getSavedPlans()
								.then((res) => {})
								.catch((error) => {});
						}, 500);
					})
					.catch((error) => {});
				}).catch(error =>{
					Globals.handleError(error, "51");
				})
			})
			.catch((error) => {
				Globals.handleError(error, "51");
			});
};

PlansService.selectPaygPlan = (action) => {
	let payg_products = Storage.get("payg_products");
	let payg_plan = Storage.get("payg_plan");

	if (!Storage.get("selected_recharge")) {
		let business = Storage.get("businessConfig");
		if (business) {
			let list_of_recharges_payg = business["list_of_recharges_payg"];
			if (list_of_recharges_payg && list_of_recharges_payg[0]) {
				Storage.set("selected_recharge", list_of_recharges_payg[0]);
			}
		}
	}

	if (payg_products && payg_products[0] && payg_plan) {
		Products.selectProduct(payg_products[0], "payg_product");
		PlansService.selectCustomPlan(payg_plan);
		setTimeout(() => {
			PlansService.checkInternationalMinutes(action);
		}, 100);
	}
};

PlansService.selectCustomPlan = (selectedPlan, lock_trigger_type = false) => {
	Storage.clear("preset");
	Storage.set("selectedCustomPlan", selectedPlan);
	let custom_combo = PlansService.getCustomCombo(selectedPlan);
	Storage.set("custom_combo", custom_combo, true);
};

PlansService.getCustomCombo = (plan) => {
	let values = [];

	for (let type of Settings.types) {
		let subplan_id = plan["vmo_subplans_ids_by_type"][type];
		let subplan = plan["vmo_subplans"][subplan_id];
		let val = subplan["vmo_ValueFormatted"];
		if (val === Settings.unlimited_text) {
			val = Settings.unlimited_text_short;
		}
		values.push(val);
	}

	let dashed_plan = values.join("-");
	let commitment = plan.product
		? plan.product.CommitmentDuration
		: Products.getCurrentProductCommitment();
	let custom_combo = commitment + "-" + dashed_plan;
	return custom_combo;
};

PlansService.updateCustomCombo = (product) => {
	let values = PlansService.getCustomCombo(Storage.get("selectedCustomPlan"));
	let dashed_plan = values.split(/-(.*)/s)[1];
	let commitment = product.CommitmentDuration || Products.getCurrentProductCommitment();
	let custom_combo = commitment + "-" + dashed_plan;
	Storage.set("custom_combo", custom_combo, true);
};

PlansService.getPlansByProductCodes = (type) => {
	let products = Storage.get("products") || [];

	let codes = [];

	for (let product of products) {
		codes.push(product.ProductCode);
	}

	let fetcher = PlansService["fetch" + type + "ByProductCode"];

	fetcher(type, codes.join(","), "1,3,4,10")
		.then((resp) => {
			let PlansbyProductCode = MiddleMan.processAvailablePlansAPI(resp.data);
			Storage.setShared("PlansbyProductCode", PlansbyProductCode);
		})
		.catch((error) => {});
};

PlansService.getMinorPlans = () => {
	let products = Storage.get("products") || [];
	// use monthly commitment always with minor plans:
	let monthly = products.find(c => c.CommitmentDuration === 1 && c.ProductCategory==='Commitment')
	let codes = [monthly.ProductCode]
	
	let fetcher = PlansService["fetchAvailablePlansByProductCode"];

	return fetcher("AvailablePlans", codes , "1,3,4,10" , true);
};


PlansService.getSavedPlans = () => {
	if (Storage.get("fetching_saved_plans")) {
		return Helpers.emptyReject();
	}

	let flags = Storage.get("flow_status_flags");
	if (!flags || !flags.is_plan_selected) {
		return Helpers.emptyReject();
	}

	Storage.set("fetching_saved_plans", true);

	let f = PlansService.fetchSavedPlans();

	f
		.then((response) => {
			let saved_product = response.data.product;

			// if(!saved_product){
			// 	saved_product = {"CommitmentDiscountPercent": 50, "CommitmentDuration": 12, "CurrencyDesc": "AED", "CustomerProfile": "VM_Customer", "EndDateTime": "", "Name": "ProductB-12Months", "ProcessRestriction": ["unlimited_booster", "mnp", "manual_retry", "schedule_pause", "change_product"], "ProductCategory": "Commitment", "ProductCode": 5, "ProductId": 164, "ProductPaymentMethods": [{"Id": 6, "Name": "6", "Priority": 1 }, {"Id": 22, "Name": "22", "Priority": 1 }, {"Id": 19, "Name": "19", "Priority": 1 }, {"Id": 14, "Name": "14", "Priority": 2 }, {"Id": 21, "Name": "21", "Priority": 2 }, {"Id": 14, "Name": "14", "Priority": 2 }, {"Id": 2, "Name": "2", "Priority": 3 }, {"Id": 20, "Name": "20", "Priority": 3 }, {"Id": 2, "Name": "2", "Priority": 3 }, {"Id": 3, "Name": "3", "Priority": 4 }, {"Id": 18, "Name": "18", "Priority": 4 }, {"Id": 3, "Name": "3", "Priority": 4 }, {"Id": 4, "Name": "4", "Priority": 5 }, {"Id": 4, "Name": "4", "Priority": 5 }, {"Id": 12, "Name": "12", "Priority": 6 }, {"Id": 22, "Name": "22", "Priority": 6 }, {"Id": 11, "Name": "11", "Priority": 7 }, {"Id": 14, "Name": "14", "Priority": 8 }, {"Id": 2, "Name": "2", "Priority": 9 }, {"Id": 3, "Name": "3", "Priority": 10 }], "StartDateTime": "18-06-2018 06:56:15", "StatusDesc": "Active", "StatusId": 2, "VanityLevel": "1,2", "WithdrawalDateTime": ""}
			// }

			Products.selectProduct(saved_product, "saved_product");

			let plan =
				response.data.save_plans && response.data.save_plans[0]
					? response.data.save_plans[0]
					: null;
			if (plan) {
				plan.product = saved_product;

				let saved_plan = MiddleMan.processSavedPlan(plan);

				let promotions = Promotions.getPromotionsByPlan(saved_plan);

				let promo = Promotions.calculateUserAndPlanPromotions(saved_plan);

				Storage.set("promotions", promotions, true);

				Storage.set("saved_plan", {...saved_plan, promo: promo}, true);

				// Events.when_plan_is_selected(saved_plan);

				PlansService.setReservationTypes("1,3").then(
					(response) => {
						if (
							response.data &&
							response.data.numbers &&
							response.data.numbers[0] &&
							response.data.numbers[0].MSISDN
						) {
							Numbers.setNumber(response.data.numbers[0]);
							
						}
					}
				);
			} else {
				Storage.clear("saved_plan");
				Storage.clear("selectedPlanSpecsIDs");
			}
		})
		.catch((error) => {})
		.finally(() => {
			Storage.clear("fetching_saved_plans");
		});

	return f;
};

PlansService.getVanityPlans = () => {
	let vanities = Products.getVanityIds();

	for (let vanity_id of vanities) {
		Storage.getOrfetch("vanity_plan_" + vanity_id, () => {
			return PlansService.fetchPlanByVanityLevel({ VanityLevel: vanity_id });
		})
			.then((response) => {
				if (response) {
					if (response.data) {
						let vanity_plan = response.data;
						if (vanity_plan.plans) {
							vanity_plan = MiddleMan.processVanityPlan(vanity_plan);
							Storage.setShared("vanity_plan_" + vanity_id, vanity_plan);
						}
					}
				}
			})
			.catch((err) => {});
	}
};

PlansService.getPaygPlans = () => {
	let payg_products = Storage.get("payg_products");

	if (payg_products && payg_products[0]) {
		let payg_product = payg_products[0];

		let PlansbyProductCode = Storage.get("PlansbyProductCode");

		// 0580000000 is intentionally hardcoded

		PlansService.fetchBoosters(
			"0580000000",
			payg_product.ProductCode,
			false
		).then((res) => {
			if (res.data) {
				Storage.setShared(
					"boosters_no_limit",
					MiddleMan.processBoosters(res.data, false)
				);
			}
		});
		PlansService.fetchBoosters(
			"0580000000",
			payg_product.ProductCode,
			true
		).then((res) => {
			if (res.data) {
				Storage.setShared(
					"boosters_with_limit",
					MiddleMan.processBoosters(res.data, true)
				);
			}
		});

		if (
			payg_product &&
			PlansbyProductCode &&
			PlansbyProductCode[payg_product.ProductCode]
		) {
			let product_plans = PlansbyProductCode[payg_product.ProductCode];
			if (product_plans["vmo_packages"]) {
				let payg_plan_lookup = Object.keys(product_plans["vmo_packages"]);
				if (payg_plan_lookup && payg_plan_lookup[0]) {
					payg_plan_lookup = payg_plan_lookup[0];
					let payg_plan = product_plans["vmo_packages"][payg_plan_lookup];
					Storage.set("payg_plan", payg_plan);
				}
			}
		}
	}
};

PlansService.fetchAvailablePlansByProductCode = (type, code, service_types ="1,3,4,10", minorsPlans=false ) => {
	let minors = minorsPlans? '&features=minor' : ''
	if (Storage.get("fetched" + type + "ByProductCode")) {
		Helpers.log("found " + type + " in storage.. ");
		let data = Storage.get("fetched" + type + "ByProductCode");
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		if (Storage.get("fetching_available_plans_" + code)) {
			return Helpers.emptyReject();
		}

		Storage.set("fetching_available_plans_" + code, true);
		let config = {
			method: "get",
			url:
				"/products/available_plans?product_codes=" +
				code +
				"&service_types="+service_types +
				minors,

		};
		let f = HTTP(config);
		f.finally(() => {
			Storage.clear("fetching_available_plans_" + code);
		});
		return f;
	}
};

PlansService.fetchPlanByVanityLevel = (numberObj) => {
	let num = "";
	if (numberObj.MSISDN) {
		num = Helpers.getNumberWithoutCountryCode(numberObj.MSISDN);
	}

	let vanity = Helpers.getVanityLevel(numberObj);

	let config = {
		method: "get",
		url:
			"/plans/by_vanity_level.json?number=" + num + "&vanity_level=" + vanity,
	};
	return HTTP(config);
};

PlansService.fetchSavedPlans = () => {
	let config = {
		method: "get",
		url: "/plans/saved_plans",
	};
	return HTTP(config);
};

PlansService.fetchBoosters = (msidsn, product_code, daily = false) => {
	let filter = daily ? "&filters=dailyallowance" : "";
	let config = {
		method: "get",
		url:
			"/boosters/" +
			msidsn +
			"?product_code=" +
			product_code +
			"&plan_type=3,1,4" +
			filter,
	};
	return HTTP(config);
};

PlansService.fetchAvailablePlans = () => {
	let config = {
		method: "get",
		url: "/plans/available?plan_types=1,3,4",
	};
	return HTTP(config);
};
PlansService.fetchLoyaltyPoints = (accountId) =>{
	let config = {
		method : "get",
		url: `loyalty/points.json?account_number=${accountId}`
	}
	return HTTP(config)
}

PlansService.saveBundlePlan = (plan_ids,product_code) => {

	let config = {
		method: "post",
		url: "/plans/saved_plans",
		data: {
			plan_ids,
			product_code
		},
	};
	return HTTP(config);
}

// eligible plans: above 2GB Data
PlansService.isEligibleToEsimOffer = () => {
	// let yearly = false;
	let moreThan2GB = false;
	let saved_plan = Storage.get("saved_plan");
	// if (saved_plan?.product?.CommitmentDuration === 12){
	// 	yearly = true;
	// }
	let plans = saved_plan?.Plans
	if (plans){
		let dataPlan = Object.keys(plans).find(p=>plans[p]?.Type === "DATA");
		if (dataPlan){
			let data_value = plans[dataPlan]['vmo_ValueFormatted'];
			data_value = parseInt(data_value);
			if (data_value === -1 ||  data_value>= 2){
				moreThan2GB = true;
			}
		}
	}
	return moreThan2GB;
}

PlansService.afterSelectingPlanAndNumber = (saved_plan) => {
	if (!saved_plan) saved_plan = Storage.get("saved_plan");
	let devicePlan = userHasDevicePlan();
	if(PlansService.isPlanYearly(saved_plan) && !devicePlan){
		Flow.goTo("/device-selection");
	}else{
		Flow.next();
	}
}

PlansService.isPlanYearly = (saved_plan) => {
	if (!saved_plan) saved_plan = Storage.get("saved_plan");
	let commitment = saved_plan?.product?.CommitmentDuration;
	return commitment === 12;
}

PlansService.isMinorPlan = () => {
	let flags = Storage.get("flow_status_flags")
	return flags?.is_minor_plan_selected === true;
}

const moiPlanCheck = () => {
	if (PlansService.isMinorPlan()) return false;
	let saved_plan = Storage.get("saved_plan");
	let devicePlan = userHasDeviceByDeliveryType(saved_plan);
	if (devicePlan) return false;
	let vip = PlansService.isVipPlan();
	if (vip) return false;
	let flags = Storage.get("flow_status_flags");
	if (flags && flags.is_assisted) return false;
	return true;
}

export {
	moiPlanCheck
}
export default PlansService;
